import { render, staticRenderFns } from "./ChangeSpecimenToPublic.vue?vue&type=template&id=2aeb9e72&scoped=true"
import script from "./ChangeSpecimenToPublic.vue?vue&type=script&lang=js"
export * from "./ChangeSpecimenToPublic.vue?vue&type=script&lang=js"
import style0 from "./ChangeSpecimenToPublic.vue?vue&type=style&index=0&id=2aeb9e72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aeb9e72",
  null
  
)

export default component.exports